module.exports = __webpack_public_path__ + "img/lk.64e22cbb.svg";